import {Component, effect, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core';
import {Tipos} from "../../../auth/register/interfaces/tipos";
import {RegistroService} from "../../../auth/register/services/registro-service";
import {PersonasService} from "../../services/personas-service";
import {MessageService} from "primeng/api";
import {CatalogoInterface, ProyectoResponse} from "../../../users/interfaces/proyecto.interface";
import {TramiteItem} from "../../../users/tramites/components/interfaces/tramites.interface";
import {defaultProyectoPerfil} from "../../../users/interfaces/perfil.interface";
import {TipoAutorizaciones} from "../../interfaces/shared-interface";

@Component({
    selector: 'shared-consulta-usuario',
    providers: [MessageService],
    templateUrl: './consulta-usuario.component.html',
    styleUrls: ['./consulta-usuario.component.css']
})
export class ConsultaUsuarioComponent {
    @Input() _tiposDocumento: Tipos[] = []
    @Input() _tipoDocumento: Tipos | null = null
    /**
     * Input que recibe el número de documento digitado en pantalla.
     */
    documento: string | undefined;
    @Input() _showLoader: boolean = false
    @Input() cardStyle: string | null | undefined = ""
    /**Tipo de respuesta a filtrar en el componete con la informacion*/
    @Input() typeFilter:number=0;
    /**Tipo de persona a procesar cuando se registra la nueva persona si no se encunetran datos en la busqueda*/
    @Input() typeActionTo!: number;
    /**
     * Este botón permite agregar una nueva persona o usuario cuando se realiza búsqueda de personas en autorizaciones y tiene una respuesta
     * ádemas solo se renderiza cuando es proceso de autorizaciones
     */
    @Input() bottonAddTemplate!:TemplateRef<any>;
    /**
     * Este elemento permite utilizar el template que hace referencia a `responseUsuario`.
     * La opción `{static: false}` indica que el elemento puede no estar presente en la plantilla, ya que su presencia depende de una condición establecida con `*ngIf`.
     */
    @ViewChild('responseUsuario', { static: false }) responseUsuario!: TemplateRef<any>;
    @Output() onResponseUserEmitter = new EventEmitter<TemplateRef<any>>();
    @Output() itemClicked = new EventEmitter<{event: Event, operationType: number }>();

    openDialogPersona: boolean=false;
    constructor(public personasService: PersonasService, protected registroService: RegistroService) {
    }
    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
        this.loadTiposDocumento()
    }
    private loadTiposDocumento() {
        return this.registroService.getTiposDocumento()
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        this._tiposDocumento = (result.body!);
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
    }
    protected consultaPorTipoDocumento(idTipoDocumento: number) {
        console.log(`documento:${this.documento}, idTipoDocumento:${idTipoDocumento}`);
        let documentoParseado = this.personasService.sanitizarDocumento(this.documento!);
        let docs: { [key: number]: string } = {[idTipoDocumento]: documentoParseado};
        //0. Validar documento previo a invocar API de busqueda.
        if (this.personasService.validarDocumentos(docs)) {
            this._showLoader = true
            this.personasService.consultaInfoPorTipoDocumento(documentoParseado, idTipoDocumento, null);
            this.resetStatus();
            this.personasService.validStatuConsultaPorTitular.set(false);
        }
    }

    /**ejecuta la opcion de busqueda y asigna el tipo documento cuando  se proceso el registro
     * de la nueva persona con exito en el componente usuario-dialog*/
    onDocumentoProcesado(event: {documento:string; idTipoDocumento:number}): void{
        this.documento=event.documento;
    }
    openDialogNuevaPersona(){
        if(this.typeFilter!=null){
            if(this.typeFilter==1){ //tipo de filtro para permitir agregar nueva persona
                this.openDialogPersona=this.personasService.noresults();
            }
        }
    }

    closeDialogUser(event: {loading:boolean; case:string}): void {
        if(event.case=='close'){
            this.openDialogPersona=false;
        }
    }
    setSelectedOption(idTipoDocumento: number): void {
        const findDocumento = this._tiposDocumento.find(option => option.idTipoDocumento === idTipoDocumento);
        if (findDocumento) {
            this._tipoDocumento = findDocumento; // Actualiza el tipo de documento seleccionado
        } else {
            console.log('No se pudo asignar el tipo de documento opción no encontrada,');
        }
    }

    private resetStatus() {
        console.log(`resetStatus()`)
        setTimeout(() => {
            if (this._showLoader) {
                this._showLoader = false
            }
            this.documento = ""
        }, 100);
    }

    onItemClickedButtonAdd(operationType: number, event: Event) {
        if(operationType==1){
            this.itemClicked.emit({ event, operationType});
            this.openDialogPersona=true;
        }
    }
    validTemplateResEffect = effect(() => {
        if (this.personasService.validTemplateResponse()) { //emite la senial al componente que lo reutiliza
            this.onResponseUserEmitter.emit(this.responseUsuario)
        }
    });

    ngOnDestroy(): void {
        this.documento = ""
        this._tipoDocumento = null
        this.personasService.validTemplateResponse.set(false)
        this.registroService.preregistroExito.set(false)
    }
}
